// Mock data fallback for company currencies
const mockCompanyCurrencies = [
  {
    id: 1,
    companyId: 1,
    currencyCode: 'USD',
    isDefault: true,
    exchangeRate: 1.0,
    createdAt: '2024-01-01T00:00:00Z'
  }
];

import { getCurrentCompanyId } from '../utils/auth';

export const getCompanyCurrencies = async (companyId = null) => {
  try {
    const actualCompanyId = companyId || getCurrentCompanyId();
    if (!actualCompanyId) {
      console.warn('No company ID available, using mock data');
      return mockCompanyCurrencies;
    }
    
    // For now, return mock data since company currency API might not be available
    console.log('Getting company currencies for company:', actualCompanyId);
    return mockCompanyCurrencies;
  } catch (error) {
    console.error('Error in getCompanyCurrencies, using mock data:', error);
    return mockCompanyCurrencies;
  }
};

export const setCompanyCurrency = async (companyId, currencyCode, isDefault = false) => {
  try {
    console.log(`Setting currency ${currencyCode} for company ${companyId}`);
    return {
      id: Date.now(),
      companyId,
      currencyCode,
      isDefault,
      exchangeRate: 1.0,
      createdAt: new Date().toISOString()
    };
  } catch (error) {
    console.error('Error setting company currency:', error);
    throw error;
  }
};

export const updateCompanyCurrency = async (id, currencyData) => {
  try {
    console.log('Updating company currency:', id, currencyData);
    return { id, ...currencyData, updatedAt: new Date().toISOString() };
  } catch (error) {
    console.error('Error updating company currency:', error);
    throw error;
  }
};

export const deleteCompanyCurrency = async (id) => {
  try {
    console.log('Deleting company currency:', id);
    return true;
  } catch (error) {
    console.error('Error deleting company currency:', error);
    throw error;
  }
};

/**
 * Get the currency for the current user's company
 * @returns {Promise<string>} Currency code (e.g., 'USD', 'KES', 'EUR')
 */
export const getUserCompanyCurrency = async () => {
  try {
    // For now, return USD as default since we're not using Supabase
    // This can be enhanced later to get from user preferences or company settings
    return 'USD';
  } catch (error) {
    console.error('Error getting company currency:', error);
    return 'USD'; // Fallback to USD on error
  }
};

/**
 * Format amount with company currency
 * @param {number} amount - Amount to format
 * @param {string} currency - Currency code (optional, will fetch if not provided)
 * @returns {Promise<string>} Formatted currency string
 */
export const formatCompanyCurrency = async (amount, currency = null) => {
  try {
    const currencyCode = currency || await getUserCompanyCurrency();
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currencyCode
    })?.format(amount);
  } catch (error) {
    console.error('Error formatting currency:', error);
    // Fallback to USD formatting
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    })?.format(amount);
  }
};